export const boardsteps = () => [
  {
    target: '[data-tour="board-search"]',
    title: 'Search Board',
    content:
      'Search work items displayed on the Kanban board.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="board-filter"]',
    title: 'Board Filters',
    content:
      'Filter work items before viewing them on the board.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="kanban-board"]',
    title: 'Kanban Board',
    content:
      'Track work items as they move through different workflow stages.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="create-task"]',
    title: 'Create Work Item',
    content:
      'Create a new work item directly from the board.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="board-column"]',
    title: 'Workflow Columns',
    content:
      'Each column represents a workflow stage. Drag and drop work items between columns to update their status.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="task-card"]',
    title: 'Work Item Card',
    content:
      'Click a work item to view its details. You can also drag it to another column to update its progress.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="epic-section"]',
    title: 'Epic Groups',
    content:
      'Work items are organized under Epics. Expand or collapse an Epic to focus on related work.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="column-menu"]',
    title: 'Column Options',
    content:
      'Manage workflow columns, including deleting custom columns if you have the required permissions.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="task-options"]',
    title: 'Work Item Actions',
    content:
      'Open the options menu to edit, delete, or perform additional actions on a work item.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="export-data"]',
    title: 'Export Data',
    content:
      'Export all epics, tasks, and subtasks for this project into a spreadsheet.',
       disableBeacon: true,
  },
  {
    target: '[data-tour="sprint-check"]',
    title: 'Active Sprints',
    content:
      'Check active sprints and track their progress at a glance.',
       disableBeacon: true,
  },
];